import type { SVGProps } from 'react';
const DawnFlagCL = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-CL_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-CL_svg__a)">
      <path fill="#EA3B2E" fillRule="evenodd" d="M0 16h22V7.467H0z" clipRule="evenodd" />
      <path fill="#0B48C2" d="M0 0h7.333v7.467H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m3.667 4.565-1.232.894.454-1.468-1.215-.917 1.512-.014.48-1.46.48 1.46 1.513.014-1.215.917.454 1.468z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagCL;
